<template>
  <TableTemplate
    v-model="mappeDefaultProductsFields"

    :columns="tableColumns"
    :columnVariables="tableColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"
    :uploadFileFromTable="true"

    :newlyCreatedAlertKey="newlyCreatedAlertKey"
    :page="page"
    :max="max"
    :selected="selected"
    :fieldsWithCommas="fieldsWithCommas"
    :extendedSlots="extendedSlots"

    :remove-cursor='true'
    :remove-row-click="true"
    :enable-sorting="true"
    :hidePagination="hidePagination"
    :remove-card="removeCard"
    :raw-table="rawTable"
    :removeHeader="removeHeader"
    @update-column-order="updateColumnOrder"

    @set-page="v => page = v"
    @prepare-full-select="fullSelectGetSkus"

    ref="table"
  >
    <template #new-item-alert-content="props">
      <slot name="new-item-alert-content" v-bind="props"></slot>
    </template>

    <template #above>
      <TableHeader class="TableHeader"
        v-model="selecting"

        :title="computedTitle"
        :showButton="showButton"
        :refetch="refetch"
        :alwaysShowMultiSelectCheckbox='true'
        :mobile-responsive-header="true"
        :exportParams="exportEndpointParams"
        select-multiple-value="Producten selecteren"

        csv-name="products"
        export-endpoint="/api/products/export"

        @customize-layout="customizeLayout"
        @setting-layout="customizeSetting"
      >
        <template #after-title>
          <slot name="after-title"></slot>
        </template>

        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>

          <div leave-class="d-flex align-items-center">
          <!-- <div>
            <button class="btn btn-secondary filter-button mr-2">fwfwfwefw</button>
          </div> -->
            <input v-if="showFile" ref="import-file" type="file" id="import-file" style="display: none" @change="importFile" multiple>
            <button class="btn btn-secondary filter-button mr-2" @click="$refs['import-file'].click()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke-width="1.5" width="17" height="17">
                <path fill-rule="evenodd" d="M11.47 2.47a.75.75 0 011.06 0l4.5 4.5a.75.75 0 01-1.06 1.06l-3.22-3.22V16.5a.75.75 0 01-1.5 0V4.81L8.03 8.03a.75.75 0 01-1.06-1.06l4.5-4.5zM3 15.75a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
              </svg>

              Import products(CSV)
            </button>
            <button v-if="hasFilters" class="btn btn-secondary filter-button mr-2" @click="clearFilters">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="17" height="17">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
              </svg>

              Reset filters
            </button>
            <button class="btn btn-secondary filter-button mr-2" @click="showFilters = !showFilters">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
                <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><path d="M13.5.5H.5a6.51,6.51,0,0,0,5,6.33V13.5l3-2V6.83A6.51,6.51,0,0,0,13.5.5Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path></g>
              </svg>

              {{ !showFilters ? "Filters  " : "Verberg filters" }}
            </button>
          </div>
        </template>

        <template #header-buttons-after="props">
          <slot name="header-buttons-after" v-bind="props"></slot>

          <div>
            <CheckboxOptions ref="assign-to-website-checkbox"
              class="select-website-checkbox-options"

              :selected.sync="selectingWebsitesToFocus"

              endpoint="/api/websites"
              search-query="name"
              item-name="name"
              type="name"
            >
              <span class="select-website">
                Selecteer website:
              </span>

              <template v-if="selectingWebsitesToFocus.length || online.length" #end-of-list="{ close }">
                <div class="d-flex">
                  <button class="mx-2 btn btn-primary flex-grow-1" @click="assignSelectionToFocusedWebsites(close)">
                    Opslaan
                  </button>
                </div>
              </template>
            </CheckboxOptions>
          </div>
        </template>
      </TableHeader>

      <transition
        @enter="enterTrans"
        @leave="leaveTrans"
      >
        <div v-if="showFilters" class="mb-3">
          <TableProductFilters
            :sku.sync="sku"
            :images.sync="images"
            :short_description.sync="short_description"
            :description.sync="description"
            :url.sync="url"
            :tax.sync="tax"
            :ean13.sync="ean13"
            :width.sync="width"
            :height.sync="height"
            :depth.sync="depth"
            :weight.sync="weight"
            :thank_you_page_discount_type.sync="thank_you_page_discount_type"

            :buy_price.sync="buy_price"
            :min_buy_price.sync="min_buy_price"
            :max_buy_price.sync="max_buy_price"

            :special_price.sync="special_price"
            :min_special_price.sync="min_special_price"
            :max_special_price.sync="max_special_price"

            :recommended_retail_price.sync="recommended_retail_price"
            :min_recommended_retail_price.sync="min_recommended_retail_price"
            :max_recommended_retail_price.sync="max_recommended_retail_price"
            :wholesale_ean.sync="wholesale_ean"
            :wholesale_price.sync="wholesale_price"
            :min_wholesale_price.sync="min_wholesale_price"
            :max_wholesale_price.sync="max_wholesale_price"

            :wholesale_stock.sync="wholesale_stock"
            :min_wholesale_stock.sync="min_wholesale_stock"
            :max_wholesale_stock.sync="max_wholesale_stock"

            :product_stock.sync="product_stock"
            :min_product_stock.sync="min_product_stock"
            :max_product_stock.sync="max_product_stock"
            :active.sync="active"

            :supplier.sync="suppliers"
            :brand.sync="brands"
            :category.sync="categories"
          />
        </div>
      </transition>

      <div class="filter-wrapper d-flex justify-content-between align-items-center">
        <div class="d-flex responsive-flex responsive-flex--filters">
          <slot name="before-search-field" :showButton="showButton" :refetch="refetch"></slot>

          <TableMainSearchField class="mr-2" v-model="search"/>
          <RefreshBtn
            :loading="isLoadingTableResult"
            @click.native="isSelectAll ? hardRefresh(refresh) : refresh()"
            class="mr-2"
            style="margin-left: 0 !important;"
          />
          <div class="d-flex checkbox-options">
            <CheckboxOptions
              v-if="selected.length"
              :selected.sync="selectedWebsites"
              :resetWhenClose="true"
              :disabled="loadingFullSelect"

              ref="assign-to-website-checkbox"
              endpoint="/api/websites"
              search-query="name"
              item-name="name"
              type="name"
            >
              <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#999999">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
              </svg>

              <span :class="loadingFullSelect && 'ske'">
                Product toewijzen aan
              </span>

              <template v-if="selectedWebsites.length" #end-of-list>
                <div class="d-flex">
                  <button class="mx-2 btn btn-primary flex-grow-1" @click="assignProductsToWebsite">
                    Opslaan
                  </button>
                </div>
              </template>
            </CheckboxOptions>
          </div>

          <button class="btn" @click="selectAll" v-if="isSelectAllVisible">
            Alle {{ total }} selecteren
          </button>
        </div>


        <div class="d-flex flex-row-reverse">
          <MultiplePageSizesSelection
            v-model="page_size"
            :available-values="availablePageSizeValues"
          />

        </div>
      </div>
      <transition
        @enter="enterTrans"
        @leave="leaveTrans"
      >
        <div v-if="online.length">
          <div class="mt-2">
            <span v-for="(item, index) in online"
              class="website-item align-items-center"
              :style="{color: productenColors[index]}"
              @click="configureWebsiteProductenColumns(item, index)"
              :key="index"
            >
              <span>
                {{ item.name }}
              </span>

              <svg class="ml-1 remove-website" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="currentColor" @click.stop="deselectWebsite(item.uid)">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>

              <div :style="{backgroundColor: productenColors[index]}" style="pointer-events: none;"></div>
            </span>
          </div>
        </div>
      </transition>
    </template>

    <slot :refetch="refetch"></slot>

    <template v-if="loaded" #row-action="props">
      <slot name="final-column-item" :refetch="refetch" v-bind="props"></slot>
    </template>

    <template v-for="(_, name) in $scopedSlots"
      slot-scope="slotData"
      :slot="name"

      v-if="name"
    >
      <slot
        :name="name"
        :refetch="refetch"

        v-bind="slotData"
      />
    </template>

    <template
      v-for="field in [...editableFields, ...editablePriceFields, ...booleanFields]"
      v-slot:[`cell-${field}`]="{value, item, extendedSlot, web_producten_uid}"
    >
      <EditableTableItem v-if="editableFields.includes(field)"
        :class="extendedSlot ? extendedSkeletonClass : skeletonClass"

        :value="value"
        @save="newValue => extendedSlot ? updateWebProductWithMessage({ [field]: newValue }, item.sku, web_producten_uid) : updateProductWithMessage(item.sku, { [field]: newValue })"
      >
        {{ value }}
      </EditableTableItem>
      <EditablePrice v-else-if="editablePriceFields.includes(field)"
        :value="value"
        :class="extendedSlot ? extendedSkeletonClass : skeletonClass"
        @save="newValue => extendedSlot ? updateWebProductWithMessage({ [field]: newValue }, item.sku, web_producten_uid) : updateProductWithMessage(item.sku, { [field]: newValue })"
      />
      <FormCheckbox v-else-if="booleanFields.includes(field)"
        :value="value"
        :disable-toggle="true"
        @click.native="updateProductWithMessage(item.sku, { [field]: !value })"
      ></FormCheckbox>
    </template>

    <template #cell-name="nameProps">
      <slot name="name" v-bind="nameProps" :refetch="refetch">
        <span @click="setLocalStorageTopDistance($event)" :class="nameProps.extendedSlot ? extendedSkeletonClass : skeletonClass">
          <router-link v-if="!nameProps.extendedSlot"
            class="name-wrapper"
            :to="`/admin/product/edit/${nameProps.item.sku}`"
          >
            {{ nameProps.value }}
          </router-link>
          <span v-else>
            {{ nameProps.value }}
          </span>
        </span>
      </slot>
    </template>

    <template #cell-wholesale_price="{value, item, extendedSlot, web_producten_uid}">
      <EditablePrice
        :value="value"
        :class="extendedSlot ? extendedSkeletonClass : skeletonClass"
        @save="newValue => extendedSlot ? updateWebProductWithMessage({ wholesale_price: newValue }, item.sku, web_producten_uid) : updateProductWithMessage(item.sku, { wholesale_price: newValue })"
      />
      <span v-if="item.wholesale_price != '---'"
        class="badge ml-2" :class="isExactFormulaPercentage(item) ? 'badge-success' : 'badge-info'">
        {{ pricePercentage(item) }} %
      </span>
    </template>

    <template #cell-active="{value, item, extendedSlot, web_producten_uid}">
      <span :class="extendedSlot ? extendedSkeletonClass : skeletonClass">
        <FormButtonCheckbox
          :value="value"
          :active="value"
          :removeCheckbox="true"
          @click.native.stop.prevent="extendedSlot ? makeWebProductActive(value, item.sku, web_producten_uid) : makeProductActive(item)"
        >
          {{ value ? "Actief" : "Unactief" }}
        </FormButtonCheckbox>
      </span>
    </template>

    <template #cell-print="{value, item, extendedSlot}">
      <span :class="extendedSlot ? extendedSkeletonClass : skeletonClass">
        <input type="text" :id="`print-${item.sku}`"/>
        <button @click="handlePrint(item)" class="btn btn-grey">
          Print <i class="fa fa-print"></i>
        </button>
      </span>
    </template>

    <template #cell-brand="{value, item, extendedSlot}">
      <span :class="extendedSlot ? extendedSkeletonClass : skeletonClass">
        {{ value && value.name ? value.name : "---" }}
      </span>
    </template>

    <template #cell-supplier="{value, item, extendedSlot}">
      <span :class="extendedSlot ? extendedSkeletonClass : skeletonClass">
        {{ value && value.name ? value.name : "---" }}
      </span>
    </template>


    <template #cell-ean13="{value, item, extendedSlot, web_producten_uid}">
      <EditableBarcode
        :class="extendedSlot ? extendedSkeletonClass : skeletonClass"
        :value="value || '---'"
        @save="ean13 => extendedSlot ? updateWebProductWithMessage({ean13}, item.sku, web_producten_uid) : updateProductWithMessage(item.sku, {ean13})"
      >
      </EditableBarcode>
    </template>

    <template #cell-categories="{ item }">
      <div v-if="item.categories.length">
        {{ item.categories.map(cat => cat.category).join(', ') }}
      </div>
      <div v-else>
        ---
      </div>
    </template>

    <template #cell-fix_mailbox="{value, item}">
      <!-- The difference between @toggle and @input event, is that @toggle only runs on click, @input also runs on the @created lifehook -->
      <FormCheckbox :value="fitsInMailbox(item)" :disable-toggle="true" @click.native="toggleMailbox(item, !fitsInMailbox(item))"></FormCheckbox>
    </template>
    <template #cell-is_in_thank_you_page="{value, item}">
      <!-- The difference between @toggle and @input event, is that @toggle only runs on click, @input also runs on the @created lifehook -->
      <FormCheckbox :value="isInThankYouPage(item)" :disable-toggle="true" @click.native="toggleInThankYouPage(item, isInThankYouPage(item))"></FormCheckbox>
    </template>

    <template #cell-is_online="{value, item, extendedSlot, web_producten_uid}">
      <span :class="extendedSlot ? extendedSkeletonClass : skeletonClass">
        <FormButtonCheckbox :value="value" :active="value" :removeCheckbox="true" @click.native.stop.prevent="toggleWebsiteProducten(value, item.sku, web_producten_uid)">
          {{ value ? "online" : "offline" }}
        </FormButtonCheckbox>
      </span>
    </template>

    <template #cell-sku="{value, item, extendedSlot}">
      <span :class="[extendedSlot ? extendedSkeletonClass : skeletonClass, search === value && 'cell-highlight']">
        {{ value }}
      </span>
    </template>

    <template v-for="(_, name) in nonUsedScopedSlots"
      slot-scope="slotData"
      :slot="name"
      v-if="name"
    >
      <slot
        :name="name"
        :refetch="refetch"

        v-bind="slotData"
      />
    </template>

    <template #before-row="{item}">
      <slot name="before-row" :item="item"></slot>
    </template>

  </TableTemplate>
</template>

<script>
import FormCheckbox from "src/components/Inputs/FormCheckbox.vue"
import TableTemplate from 'src/layout/Table/TableTemplate'
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import FormButtonCheckbox from "src/components/Inputs/FormButtonCheckbox.vue"
import TableHeader from "./TableHeader.vue"
import EditablePrice from '../../../layout/EditTableItem/EditablePrice.vue'
import EditableTableItem from '../../../layout/EditTableItem/EditableTableItem.vue'
import EditableBarcode from '../../../layout/EditTableItem/EditableBarcode.vue'
import TableProductFilters from '../TableProductFilters.vue'
import RefreshBtn from '../../../layout/RefreshBtn.vue'

import MultiplePageSizesSelection from '../../../layout/Table/MultiplePageSizesSelection.vue'
import TableMainSearchField from '../../../layout/TableMainSearchField.vue'
import CheckboxOptions from '../../../layout/Table/DropdownCheckboxTableFilters/CheckboxOptions.vue'

import transitionFunctionConstructor from '../../../mixins/transitionFunctionConstructor'
import { productTypesOptions } from '../../../mixins/imageFileTypes'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import selectMultipleItems from "src/mixins/selectMultipleItems"
import table from "src/mixins/table"
import keepScroll from "src/mixins/keepScroll"
import performanceChecker from "src/mixins/performanceChecker"
import {fitsInMailbox, toggleMailBoxFitProperties, getPrice} from "@/utils/product";

const websiteProductenDefaultColumns = [
  "Verkoopprijs", "Groothandel Prijs", "Aanbieding Prijs", "Status"
]

export default ({
  components: {
    RefreshBtn,
    TableProductFilters,
    TableTemplate,
    TableActionDropdown,
    EditablePrice,
    EditableBarcode,
    EditableTableItem,
    MultiplePageSizesSelection,
    TableHeader,
    EmptyStatePlaceholder,
    TableSearchField,
    FormButtonCheckbox,
    TableMainSearchField,
    CheckboxOptions,
    FormCheckbox
  },
  props: {
    listChecked: Array,
    isSelectAll: Boolean,
    newlyCreatedAlertKey: String,
    title: {
      type: String,
      required: true,
    },
    extraParams: {
      type: Object,
      required: false,
    },
    tableLayoutId: {
      type: String,
      required: true,
    },
    hidePagination: {
      type: Boolean,
      required: false,
    },
    removeCard: {
      type: Boolean,
      required: false,
    },
    rawTable: {
      type: Boolean,
      required: false,
    },
    removeHeader: {
      type: Boolean,
      required: false,
    },
  },
  mixins: [
    transitionFunctionConstructor("enterTrans", "leaveTrans"),
    tableFieldOptions,
    selectMultipleItems,
    performanceChecker,
    keepScroll,

    table({

      pageReference: 'all-products',

      minimumColumnSizes: {
        ean13: 140,
        print: 240,
      },
      defaultColumnSizes: {
        recommended_retail_price: 120,
        sku: 100,
        active: 100,
        tax: 100,
        wholesale_price: 115,
        buy_price: 115,
        special_price: 115,
        width: 115,
        height: 115,
        depth: 115,
        weight: 115,
        product_stock: 115,
        name: 305,
      },

      columnTranslationMaps: {
        "Hoge korting mogelijk": "high_discount_allow",
        "Lage korting toestaan": "low_discount_allow",
        "Gemiddelde korting toegestaan": "medium_discount_allow",

        "Merk": 'brand',
        "Leverancier": 'supplier',
        "Categorieën": 'categories',
        "SKU": "sku",
        "Naam": "name",
        "Korte beschrijving": "short_description",
        "Beschrijving": "description",
        // "Categorie": "category",
        // "Subcategorie": "sub_category",
        "URL": "url",
        "Belasting": "tax",
        "Barcode": "ean13",
        "Breedte": "width",
        "Hoogte": "height",
        "Diepte": "depth",
        "Gewicht": "weight",
        "Actief": "active",
        "Voorraad": "product_stock",

        /*"Prijs excl. BTW": "price_excluding_taxes",
        "Prijs incl. BTW": "price_including_vat",*/
        "Groothandel Prijs": "wholesale_price",
        "Groothandel Voorraad": "wholesale_stock",
        "Aanbieding Prijs": "special_price",
        "Koop prijs": "buy_price",
        "Verkoopprijs": "recommended_retail_price",

        "Groothandel ean13": "wholesale_ean",
        "Colli": "colli",
        "Groothandel min. aantal": "wholesale_min_qty",

        "Status": "is_online",

        "Print": "print",

        "Fits in mailbox": "fix_mailbox",
        "Op bedankpagina": "is_in_thank_you_page",
        "Uitgelichte artikel": "featured",
      },
      disableSortOnColumns: ['fix_mailbox', 'print'],
      disableColumnConfiguration: ["Status"],
      imageTypeOptions: productTypesOptions,
      getImageEndpoint: item => `/api/products/${item.sku}/files`,
      disableAlphabeticalSort: true,

      defaultColumns: [
        "Naam", "Verkoopprijs", "Korte beschrijving", "SKU", "Actief", "Barcode", "Print", "Fits in mailbox", "Op bedankpagina"
      ],

      filterSelectOptions: { // Each key represents a filter, and its value is a function that returns the <select> options.
        "tax": vueInstance => vueInstance.taxOptionsAll,
      },
      page_size: 50,
      defaultSort: "name",

      params: {
        active: undefined,
        page_size: 50,
        name: "",
        search: "",
        sku: null,
        images: null,
        short_description: "",
        description: "",
        url: "",
        tax: "",
        ean13: "",
        wholesale_ean: "",
        width: "",
        height: "",
        depth: "",
        weight: "",
        thank_you_page_discount_type: "",

        buy_price: "",
        min_buy_price: "",
        max_buy_price: "",

        special_price: "",
        min_special_price: "",
        max_special_price: "",

        recommended_retail_price: "",
        min_recommended_retail_price: "",
        max_recommended_retail_price: "",

        wholesale_price: "",
        max_wholesale_price: "",
        min_wholesale_price: "",

        wholesale_stock: "",
        min_wholesale_stock: "",
        max_wholesale_stock: "",

        product_stock: "",
        min_product_stock: "",
        max_product_stock: "",

        suppliers: [],
        categories: [],
        brands: [],
      },
      columnConfigurationId: "product-table",

      getParams: (params, vm) => ({
        ...params,
        ...(vm.extraParams || {}),
      }),
      parseParamsBeforeSending: params => {
        if ((params.sort || "").split("---")[0] === "is_online") {
          params.online = [(params.sort || "").split("---")[1]]

          params.sort = "is_online"
        }
        /* if (params.category) {
          params.categories = [params.category]
        } */

        return params
      },

      // When clicking on "select all", it will fetch all items on the background, and select every single one of them, regardless of pagination.
      allowFullSelect: true,

      isArrayQuery: ["categories", "suppliers", "brands"],
      routeTriggers: ["extraParams"],
      route: "/api/products",
    }),
  ],
  data() {
    return {
      isSelectAllVisible: false,
      showFile: true,
      excluded: [],

      editablePriceFields: ['recommended_retail_price', 'buy_price', 'special_price'],
      editableFields: ['wholesale_min_qty', 'colli', 'wholesale_stock', 'wholesale_ean', 'product_stock'],
      booleanFields: ['featured', 'high_discount_allow', 'low_discount_allow', 'medium_discount_allow'],

      selectedWebsites: [],
      showFilters: false,
      selectingWebsitesToFocus: [],
      online: [],
      websiteProductenList: [],

      websiteProductenCurrentTableColumns: [
        websiteProductenDefaultColumns,
        websiteProductenDefaultColumns,
      ],

      test : '',
      focusedSkus: [],
      loadingWebsiteProducten: false,

      /**
       * [ Mixin keepScroll ] - localStorageKey: Unique key(one per page) that will be used as a reference to set/get the element's distance from the top
       */
      localStorageKey: "position_scroll_product"
    }
  },
  async created() {
    this.getActiveColumnsFromStorage(this.tableLayoutId)

    try {
      const websites = localStorage.getItem("online-selected-websites")
      if (websites) this.online = JSON.parse(websites) || []
    } catch (err) {
      this.online = []
    }

    if (this.online.length) {
      this.selectingWebsitesToFocus = this.online.slice()
      this.fetchWebsiteProducten()
      this.getProductenCustomOders()
    }
  },
  methods: {
    async importFile() {
      const files = [...this.$refs["import-file"].files]

      const payload = new FormData()
      payload.append("filename", files[0])

      this.$handlePromise(async () => {
        const { data } = await this.axios.post(`/api/products/import`, payload, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        if (data.error) {
          this.$error(data.message)
        }
      })

      this.showFile = false
      setTimeout(() => {
        this.$nextTick(() => this.showFile = true)
      })
    },
    hardRefresh(refresh) {
      this.excluded = []
      this.selected = []
      this.isSelectAll = false
      refresh()
    },
    selectAll() {
      this.selected = [...this.listChecked]
      this.excluded = []
      this.$emit('update:is-select-all', true)
    },
    fitsInMailbox(product) {
      return fitsInMailbox(product)
    },
    toggleMailbox(product, checked) {
      // returns: {width, height, depth, weight}
      const newDimensions = toggleMailBoxFitProperties(checked, product)
      this.updateProductWithMessage(product.sku, newDimensions)
    },
    isInThankYouPage(product) {
      return product.low_discount_allow || product.medium_discount_allow || product.high_discount_allow
    },
    toggleFeatured(product, checked) {
      if (checked) {
        this.updateProductWithMessage(product, {featurd})
      }
    },
    toggleInThankYouPage(product, checked) {
      let fields = ["low_discount_allow", "medium_discount_allow", "high_discount_allow"]

      let data = {}
      if (checked) {
        fields.forEach(key => data[key] = false)
      } else {
        fields.forEach(key => data[key] = true)
      }
      console.log(product.sku, product)
      this.updateProductWithMessage(product.sku, data)
    },
    deselectWebsite(uid) {
      const index = this.online.findIndex(item => item.uid === uid)
      if (index > -1) {
        this.online.splice(index, 1)

        if (!this.online.length) {
          this.sort = "name"
          this.order = "asc"
        }

        this.$nextTick(() => this.selectingWebsitesToFocus = this.online.slice())
      }
    },
    getProductenCustomOders() {
      const newOrders = []
      this.websiteProductenCurrentTableColumns.map((item, index) => {
        let order

        try {
          order = localStorage.getItem("table-order:" + `website-producten-${index}`)
          order = order ? JSON.parse(order).filter(item => item) : websiteProductenDefaultColumns
        } catch (err) {
          order = websiteProductenDefaultColumns
        }

        newOrders.push(order)
      })
      this.websiteProductenCurrentTableColumns = newOrders
    },
    resetAllWebsiteColumnConfigurationLocalStorages() {
      Array.from({length: 50}).forEach(index => localStorage.setItem(`table-order:website-producten-${index}`, null))
    },
    configureWebsiteProductenColumns({ uid, name }, index) {
      this.$pushModal({
        modal: "CustomizeLayout",
        toBind: {
          id: `table-order:website-producten-${index}`,
          title: `Kolommen aanpassen - <b>${name}</b>`,

          columns: websiteProductenDefaultColumns.filter(col => this.currentTableColumns.includes(col)),
          defaultColumns: websiteProductenDefaultColumns,
          currentColumns: this.websiteProductenCurrentTableColumns[index].slice(),
          callback: activeValues => {
            this.websiteProductenCurrentTableColumns[index] = activeValues
            this.websiteProductenCurrentTableColumns = [...this.websiteProductenCurrentTableColumns]
            this.updateColumnOrder(null)
          },
        },
      })
    },

    async fetchWebsiteProducten() {
      this.loadingWebsiteProducten = true

      const websiteProductenList = {}
      await Promise.all(
        this.online.map(async ({uid, name}) => {
          websiteProductenList[uid] = (await this.$store.dispatch("cachedGet", {
            endpoint: `/api/websites/${uid}/products`,
            params: { params: {page_size: 10000}, sku: this.tableResult.map(item => item.sku) },
          })).data.results.map((p) => {
            p.recommended_retail_price = p.price;
            p.fix_mailbox = false;
            p.is_in_thank_you_page = false;
            p.featured = false;
            return p})
        })
      )
      this.websiteProductenList = websiteProductenList

      this.loadingWebsiteProducten = false
    },
    assignSelectionToFocusedWebsites(close) {
      this.online = this.selectingWebsitesToFocus.slice()

      this.resetAllWebsiteColumnConfigurationLocalStorages()
      if (!this.online.length) {
        this.sort = "name"
        this.order = "asc"
      }

      close && close()
      this.$nextTick(() => this.selectingWebsitesToFocus = this.online.slice())
    },
    handlePrint({ sku,ean13 }) {
      this.$handlePromise(async () => {
        const payload = { sku,ean13 }
        const input = document.getElementById(`print-${sku}`)
        const amount = input && input.value
        if (amount){ payload.quantity = parseInt(amount, 10)}else{  payload.quantity = 1;  }
        payload.status = 0
        await this.axios.post('/api/printjobs', payload)
        this.$success("Update succesvol!")
      })
    },

    toggleWebsiteProducten(online, sku, web_producten_uid) {
      this.$handlePromise(async () => {
        if (online) {
          await this.axios.delete(`/api/websites/${web_producten_uid}/products/${sku}`)
        } else {
          await this.axios.put(`/api/websites/${web_producten_uid}/products/${sku}`)
        }
        this.$store.dispatch('clearCacheSearch', "websites")
        this.$store.dispatch('clearCacheSearch', "products")

        this.fetchWebsiteProducten()
        this.$success("Succesvol geüpdatet websiteproduct!")
      })
    },
    async assignProductsToWebsite() {
      const selected = this.selected.slice()
      const websites = this.selectedWebsites.slice()

      /*
        await Promise.all(
          websites.map(async ({uid}) => {
            if (product.websites.includes(uid)) {
              await this.axios.delete(`/api/websites/${uid}/products/${sku}`)
            } else {
              await this.axios.put(`/api/websites/${uid}/products/${sku}`)
            }
          })
        )
      * */

      const allProducts = [...this.tableResult, ...this.backgroundProducts]
      const hasSelectedEverything = this.tableResult.every(product => selected.includes(product.sku))
      this.$handlePromise(async () => {
        const payload = {
          add: [],
          remove: [],
        }

        ;(
          !hasSelectedEverything
            ? selected
            : [...selected, ...this.backgroundProducts.map(prod => prod.sku)]
        ).forEach(sku => {
          const product = allProducts.find(prod => prod.sku === sku) || {websites: []}
          websites.forEach(({ uid }) => {
            if (product.websites.includes(uid)) {
              // payload.remove.push({productSku: sku, websiteUid: uid})
            } else {
              payload.add.push({productSku: sku, websiteUid: uid})
            }
          })
        })

        // {add: Array(31), remove: Array(633)}
        // {add: Array(633), remove: Array(31)}
        await this.axios.post(`/api/bulk-assign-products-to-website`, payload)
        this.$store.dispatch('clearCacheSearch', "websites")
        this.$store.dispatch('clearCacheSearch', "products")
        this.$refs["assign-to-website-checkbox"].close()
        // this.online.length && this.queryFocusedWebsiteProducts()
        this.freshRefetch()
        this.$success("Succesvol bijgewerkte websiteproducten!")
      })
    },

    async updateProductWithMessage(sku, data) {
      await this.updateSingleTableRowById(sku, data, "Product geüpdatet!")
    },
    async makeProductActive(item) {
      await this.updateSingleTableRowById(item.sku, { active: !item.active }, "Product geüpdatet!")
    },
    async makeWebProductActive(active, sku, web_producten_uid) {
      this.updateWebsiteProducten(sku, web_producten_uid, { active: !active })
    },
    async updateWebProductWithMessage(data, sku, web_producten_uid) {
      this.updateWebsiteProducten(sku, web_producten_uid, data)
    },

    async updateWebsiteProducten(sku, web_producten_uid, data) {
      if (await this.$handlePromise(
        this.axios.put(`/api/websites/${web_producten_uid}/products/${sku}`, data)
      )) {
        this.$success("Succesvol geüpdatet websiteproduct!")
        this.$store.dispatch('clearCacheSearch', "websites")
        this.$store.dispatch('clearCacheSearch', "products")
        this.fetchWebsiteProducten()
      }
    },

    customTranslationMap(translation) {
      const web = this.online.find(web => translation.includes(`">${web.name}</b>`))
      return web && `${this.columnTranslationMaps[translation.split("(")[0]]}---${web.uid}`
    },
    isExactFormulaPercentage(product) {
      const { recommended_retail_price = 0, wholesale_price = 0 } = product
      const price = Math.round(getPrice(recommended_retail_price) * 0.6 * 10) /10
      return price == getPrice(wholesale_price)
    },
    pricePercentage(product) {
      const { recommended_retail_price = 0, wholesale_price = 0 } = product
      return Math.abs(100 - parseInt(getPrice(wholesale_price) / getPrice(recommended_retail_price) * 100))
    },
    async clearFilters() {
      await this.$router.push("/admin/all-products")
      this.refetch(true, null, true)
    },
  },
  computed: {
    hasFilters() {
      return this.$route.fullPath.includes("?")
    },
    extendedSkeletonClass() {
      return (this.loadingWebsiteProducten || this.isLoadingTableResult) ? "ske" : ""
    },
    extendedSlots() {
      return this.extendedTableColumnVariables.map(field => ({
        name: field.split("---")[0],
        slot: field,
        props: {
          web_producten_uid: field.split("---")[1],
        },
      }))
    },
    extendedTableColumnVariables() {
      return this.tableColumnVariables.filter(fieldName => fieldName !== undefined ? fieldName.includes("---") : undefined)
    },
    websiteProductenTableColumns() {
      const colors = this.productenColors
      const columns = this.currentTableColumns.slice()
      const websites = this.online
      const currentTableColumns = this.websiteProductenCurrentTableColumns

      columns.push(`Status`)
      websites.forEach((web, index) => {
        if (!currentTableColumns[index]) {
          currentTableColumns.push(websiteProductenDefaultColumns)
        }
        currentTableColumns[index].forEach(webProductColumn => {
          if (webProductColumn !== 'Status') return;

          const baseColumnIndex = columns.findIndex(col => webProductColumn === col)
          if (baseColumnIndex > -1) {
            columns.splice(baseColumnIndex + index + 1, 0, `${columns[baseColumnIndex]}(<b style="color: ${colors[index]}">${web.name}</b>)`)
          }
        });
      })

      const removeMainStatusIndex = columns.findIndex(col => col === "Status")
      if (removeMainStatusIndex > - 1) columns.splice(removeMainStatusIndex, 1)

      return columns
    },

    reversedOnline() {
      return this.online.slice().reverse()
    },
    reversedColors() {
      return this.productenColors.slice().reverse()
    },
    productenColors() {
      return [
        "#16a34a",
        "#2563eb",
        "#dc2626",
        "#57534e",
        "#d97706",
      ]
    },

    disabledDragColumns() {
      return ["is_online"]
    },
    computedTitle() {
      const title = `${this.title} (${this.total})`
      if (this.selected) {
        return title + ` / ${this.isSelectAll ? this.total - this.excluded.length : this.selected.length } geselecteerd`
      }
      return title
    },
    availablePageSizeValues() {
      return [10, 20, 50, 100, 200]
      // return [10, 20, 50, 100, ["Alle", 10000]]
    },

    fieldsWithCommas() {
      return [
        "buy_price",
        "min_buy_price",
        "max_buy_price",

        "special_price",
        "min_special_price",
        "max_special_price",

        "recommended_retail_price",
        "min_recommended_retail_price",
        "max_recommended_retail_price",

        "wholesale_price",
        "max_wholesale_price",
        "min_wholesale_price",

        "product_stock",
        "min_product_stock",
        "max_product_stock",
      ]


    },
    mappeDefaultProductsFields() {
      let products = this.mappedProducts.slice()
      const websites = this.online
      if (!websites.length) return products

      const variables = this.extendedTableColumnVariables

      websites.forEach(({uid}) => {
        products.forEach((i, index) => {
          if (products[index][`is_online---${uid}`]) {
            variables.filter(field => field.includes(uid) && !field.includes("is_online")).forEach(extendedField => {
              if (products[index][extendedField] === undefined || products[index][extendedField] === null) {
                products[index][extendedField] = products[index][extendedField.split("---")[0]]
              }
            })
          }
        })
      })

      return products
    },
    mappedProducts() {
      let tableData = this.tableResult.map ? this.tableResult.map(item => ({
        ...item,
      })) : this.tableResult

      if (this.online.length) {
        const variables = this.extendedTableColumnVariables
        const websiteProductenList = this.websiteProductenList

        variables.forEach(field => {
          const website_uid = field.split("---")[1]
          const overwrittenProducts = websiteProductenList[website_uid]
          const baseField = field.split("---")[0]

          if (overwrittenProducts && overwrittenProducts.length) {
            tableData = tableData.map(row => {
              const overwritten = overwrittenProducts.find(product => row.sku === product.sku)
              row[field] = overwritten && overwritten[baseField] ? overwritten[baseField] : null
              row[`is_online---${website_uid}`] = overwritten ? true : false

              return row
            })
          } else {
            tableData = tableData.map(row => {
              row[`is_online---${website_uid}`] = false
              return row
            })
          }
        })
      }
      tableData.map(row => {
        if (row.bundle_products && row.bundle_products.length) {
          row.isSuccess = true
        }
      })

      return tableData
    },

    activeColumns() {
      return this.online.length ? this.websiteProductenTableColumns : this.currentTableColumns
    },
    table() {
      return this.$refs.table
    },
    capitalize() {
      return [false, false, false, false]
    },
    nonUsedScopedSlots() {
      const usedSlots = ['header-buttons-before', 'header-buttons-after', 'name']

      const finalSlots = {...this.$scopedSlots}
      usedSlots.forEach(slot => delete finalSlots[slot])

      return finalSlots
    },
    /* Using computed property in order to not override mixin watch: {} */
    currentSort() {
      return this.sort
    },
  },
  watch: {
    isSelectAll(value) {
      if (value) {
        this.selected = [...this.listChecked]
      }
      this.$emit("update:is-select-all", value)
    },
    listChecked(value) {
      if (this.isSelectAll) {
        this.selected = [...value]
      }
    },
    currentSort(val) {
      if (val && val.includes("is_online")) {
        this.order = "desc"
      }
    },
    online(val) {
      this.updateColumnOrder(null)

      if (val.length) {
        localStorage.setItem("online-selected-websites", JSON.stringify(val))
      } else {
        localStorage.setItem("online-selected-websites", null)
      }

      this.freshRefetch()
      this.fetchWebsiteProducten()
    },
    selected(val) {
      if (this.isSelectAll) {
        this.listChecked.filter(item => !val.includes(item)).forEach(item => {
          if (!this.excluded.includes(item)) {
            this.excluded.push(item)
          }
        });
        this.$emit("excluded", this.excluded);
      }
      if (val.length === this.result.length) {
        this.isSelectAllVisible = true
      }
      this.test = val[0]
      this.$emit("input", [...val])
    },
    tableResult(val) {
      this.$emit("table-items", val)
    },
    showButton(val) {
      this.$emit("show-button", val)
    },
    result(val) {
      this.$emit("result", [...val])
    },
    exportEndpointParams: {
      immediate: true,
      handler(val) {
        this.$emit("filters", val)
      }
    }
  },
})
</script>

<style>

.filter-wrapper .CheckboxOptions {
  font-size: 16px !important;
}

.cell-highlight {
  color: black !important;
  background-color: yellow !important;
  display: inline-block !important;
}

</style>

<style scoped>


.responsive-flex {
  flex-wrap: wrap;
}

.responsive-flex--filters {
  row-gap: 0.5rem;
}

@media (max-width: 800px) {
  .checkbox-options {
    margin-left: 0px !important;
  }

  .TableHeader {
    flex-wrap: wrap;
  }
}

.btn-grey {
  background: var(--black-40);
  color: var(--white);
  z-index: 10;
  position: relative;
}


input {
  width: 120px;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 6px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  transform: translate(2px, 0px);
}
.input-container {
  margin: 5px;
}


@media (max-width: 800px) {
  .filter-wrapper {
    flex-direction: column-reverse;
    align-items: initial;
  }

  .filter-wrapper > div {
    width: 100%;
  }
}

.select-website-checkbox-options {
  min-height: 40px;
}

.filter-button {
  background-color: #A7A9AB;
  padding: 8px !important;
  filter: brightness(1) !important;
}
.filter-button:hover {
  color: white !important;
  filter: brightness(1.08) !important;
}

.select-website {
  color: #999999;
}

.name-wrapper {
  color: currentColor;
}

.name-wrapper:hover {
  text-decoration: underline;
}

.button-icon {
  transform: translateY(-1px);
}

.drop {
  margin-top: -8px;
}

.products-counter {
  margin-left: 10px !important;
  cursor: initial !important;
  background-color: #f8f9fa !important;
  border: none !important;
}

.filter-icon, .counter {
  color: rgb(200,200,200);
}

.filter-icon {
  margin-bottom: 2px;
  margin-right: 1px;
}

.website-item {
  cursor: pointer;
  display: inline-flex;
  border-radius: 3px;
  padding: 6px 8px;
  position: relative;
  font-weight: 600;
  overflow: hidden;
  filter: brightness(1);
  transition: .15s;
}

.website-item:hover {
  filter: brightness(1.15);
}

.website-item + .website-item {
  margin-left: 7px;
}

.remove-website {
  display: block;
}

.remove-website:hover {
  color: #C7314A !important;
}

.website-item div {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  opacity: .15;
}

.copy-button {
  border: 1px solid #dee2e6;
  padding:12px 10px;
  border-radius: 2px;
  background: white;
}

.copy-button:hover{
  background: transparent;
}

</style>
